export enum ProductStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DELETED = 'deleted',
  CORRUPTED = 'corrupted',
}
